/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityFindingsResult
 */
export interface MonitEntityFindingsResult {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    entity_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    entity_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    risk?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitEntityFindingsResult
     */
    recommendation?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitEntityFindingsResult
     */
    references?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    asset?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    source_asset?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    port?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MonitEntityFindingsResult
     */
    shared?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityFindingsResult
     */
    found?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityFindingsResult
     */
    created?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityFindingsResult
     */
    updated?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    level?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    score_category?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    datapoint?: string;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof MonitEntityFindingsResult
     */
    evidences?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof MonitEntityFindingsResult
     */
    matches?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityFindingsResult
     */
    risk_score?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    finding_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    process_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    monit_type?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitEntityFindingsResult
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsResult
     */
    muted_status?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MonitEntityFindingsResult
     */
    is_contingency?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitEntityFindingsResult
     */
    resolution_types?: Array<string>;
}

/**
 * Check if a given object implements the MonitEntityFindingsResult interface.
 */
export function instanceOfMonitEntityFindingsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityFindingsResultFromJSON(json: any): MonitEntityFindingsResult {
    return MonitEntityFindingsResultFromJSONTyped(json, false);
}

export function MonitEntityFindingsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityFindingsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'risk': !exists(json, 'risk') ? undefined : json['risk'],
        'recommendation': !exists(json, 'recommendation') ? undefined : json['recommendation'],
        'references': !exists(json, 'references') ? undefined : json['references'],
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'source_asset': !exists(json, 'source_asset') ? undefined : json['source_asset'],
        'port': !exists(json, 'port') ? undefined : json['port'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'found': !exists(json, 'found') ? undefined : json['found'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
        'level': !exists(json, 'level') ? undefined : json['level'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'score_category': !exists(json, 'score_category') ? undefined : json['score_category'],
        'datapoint': !exists(json, 'datapoint') ? undefined : json['datapoint'],
        'evidences': !exists(json, 'evidences') ? undefined : json['evidences'],
        'matches': !exists(json, 'matches') ? undefined : json['matches'],
        'risk_score': !exists(json, 'risk_score') ? undefined : json['risk_score'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'finding_id': !exists(json, 'finding_id') ? undefined : json['finding_id'],
        'process_id': !exists(json, 'process_id') ? undefined : json['process_id'],
        'monit_type': !exists(json, 'monit_type') ? undefined : json['monit_type'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'muted_status': !exists(json, 'muted_status') ? undefined : json['muted_status'],
        'is_contingency': !exists(json, 'is_contingency') ? undefined : json['is_contingency'],
        'resolution_types': !exists(json, 'resolution_types') ? undefined : json['resolution_types'],
    };
}

export function MonitEntityFindingsResultToJSON(value?: MonitEntityFindingsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_name': value.entity_name,
        'entity_domain': value.entity_domain,
        'description': value.description,
        'risk': value.risk,
        'recommendation': value.recommendation,
        'references': value.references,
        'asset': value.asset,
        'source_asset': value.source_asset,
        'port': value.port,
        'shared': value.shared,
        'found': value.found,
        'created': value.created,
        'updated': value.updated,
        'level': value.level,
        'category': value.category,
        'score_category': value.score_category,
        'datapoint': value.datapoint,
        'evidences': value.evidences,
        'matches': value.matches,
        'risk_score': value.risk_score,
        'status': value.status,
        'finding_id': value.finding_id,
        'process_id': value.process_id,
        'monit_type': value.monit_type,
        'tags': value.tags,
        'muted_status': value.muted_status,
        'is_contingency': value.is_contingency,
        'resolution_types': value.resolution_types,
    };
}

